<template lang="pug">
.epidemic-prevention(@mousemove="getMouse")
  .container-fluid
    .row.prevent-top.pb-5.sub_texture
      .prevent-text.col-12.animate__animated.animate.animate__fadeIn
        h2.prevent-subtitle {{ $t(`prevent.subtitle`) }}
        h1.prevent-title(:class="{ 'title-en': $i18n.locale === 'en' }") {{ $t(`prevent.title`) }}
        a.prevent-link(
          v-for="(item, index) in preventItems",
          :key="index",
          :href="'#prevent' + index",
          :class="{ en: $i18n.locale == 'en' }"
        ) 
          | {{ $t(`prevent.prevent_${index + 1}.title`) }}
      SvgInline.prevent-bkg.animate__animated.animate.animate__fadeIn(
        src="/scenes/health_bkg.png",
        :svg="false",
        :disablePosition="true"
      )
      SvgInline.prevent-bkg.animate__animated.animate.animate__fadeIn(
        src="/scenes/health_obj.svg",
        :disablePosition="true",
        :displayExclamation="false"
      )

    .row.prevent-item.sub_texture(
      v-for="(item, index) in preventItems",
      :key="index",
      :id="'prevent' + index",
      :class="{ 'flex-row-reverse': index % 2 !== 0, 'item-r': index % 2 !== 0, en: $i18n.locale == 'en' }"
    )
      .col-12.py-3.col-lg-6
        .prevent-item-text(
          :style="{ backgroundColor: item.bg, color: item.fontClr }",
          data-aos="fade-up"
        )
          a(
            :href="$t(`prevent.prevent_${index + 1}.link`)",
            :style="{ color: item.fontClr }",
            target="_blank"
          )
            h3.mb-3 {{ $t(`prevent.prevent_${index + 1}.title`) }}
              font-awesome-icon.icon(
                :icon="'external-link-alt'",
                :style="{ fontSize: '1.2rem', marginLeft: '10px' }"
              )
          p {{ $t(`prevent.prevent_${index + 1}.desc`) }}

          img.prevent-item-img(:src="getImg(item)")
      .col-12.py-3.col-lg-6
        .prevent-item-pic(
          data-aos="fade-left"
          :style="getPreventItemStyle(index)",
        )
          img(:src="getPic(item)")
          //  :style="getPreventItemStyle(index)",
</template>

<script>
import SvgInline from "@/components/SvgInline.vue";
import AOS from "aos";
import $ from "jquery";

let bg_animation = require("@/assets/animations/health.js");
export default {
  name: "EpidemicPrevention",
  components: {
    SvgInline
  },
  created() {
    this.$store.dispatch("loadSvgData", "/scenes/health_obj.svg");
  },
  mounted() {
    this.$store.dispatch("loadSvgData", "/scenes/health_obj.svg").then(() => {
      setTimeout(() => {
        bg_animation.play();
      }, 100);
    });
    AOS.init({
      offset: 200,
      duration: 1200,
      easing: "ease-out-back",
      delay: 50
    });
  },
  methods: {
    getImg(item) {
      let img;
      try {
        img = require("@/assets/images/prevent-" + item.idx + ".png");
      } catch (e) {
        img = null;
      }
      return img;
    },
    getPic(item) {
      let pic;
      try {
        pic = require("@/assets/images/prevent-" + item.idx + "-pic.jpg");
      } catch (e) {
        pic = null;
      }
      return pic;
    },
    getMouse({ x, y }) {
      // console.log(x)
      this.mouseX = x;
      this.mouseY = y;
    },
    getPreventItemStyle(index) {
      let style = {
        backgroundImage:
          "url(" +
          require("@/assets/images/prevent-" + index + "-pic.jpg") +
          ")",
        "background-color": "rgba(26,26,26,1)",
        // "background-size": "auto 100%",
        "background-size": "cover",
        "background-position-x": 50 - this.mouseX / 100 + 5 + "%",
        "background-position-y": 50 + this.mouseY / 50 - 5 + "%"
      };
      if(index === 4){
        style.backgroundSize = "100%"
        // style.backgroundSize = "auto 100%"
        style.backgroundPositionX = `${this.mouseX / 100 + 5}%`
        style.backgroundPositionY = `${this.mouseY / 100 - 5}%`
        if(window.innerWidth > 992 && window.innerWidth < 1300){
          style.backgroundSize = "100% auto"
          style.backgroundPositionX = `${50 + this.mouseX / 100 + 5}%`
          style.backgroundPositionY = `${50 + this.mouseY / 100 - 5}%`
        }
        if(window.innerWidth >= 1300){
          // style.backgroundSize = "100% auto"
          style.backgroundSize = "auto 95%"
          style.backgroundPositionX = `${50 + this.mouseX / 100 + 5}%`
          style.backgroundPositionY = `${50 + this.mouseY / 100 - 5}%`
        }
      }
      return style
    }
  },
  data() {
    return {
      mouseX: 0,
      mouseY: 0,
      preventItems: [
        {
          idx: 0,
          name: "實名制口罩自動販賣系統",
          desc:
            "「實名制口罩自動販賣系統」試辦計畫，提倡整合創新、提昇效率、便民服務三大目標，以及提供實名制服務以及推動無現金交易，以配合中央口罩購買管制及降低疫情期間之現金接觸感染。\n為推動無現金交易，實名制口罩販賣機、及智慧化行動模組皆提供悠遊卡等便利安全的付款方式，並鼓勵民眾優先使用悠遊卡，以加速購買流程。",
          link: "",
          photo: "",
          img: "",
          bg: "#F2F2EF",
          fontClr: "#333333"
        },
        {
          idx: 1,
          name: "防疫國際交流",
          desc:
            "配合中央疫情指揮中心指示，在各場館逐步解封之際，如何因應可能的疫調作為是解封的必要處理項目，資訊局開發實名制APP(myCode)，提供本府所轄各公共場館以掃瞄證件條碼方式，快速完成實名登記作業，APP快速部署的特性，讓場館無須系統軟硬體的開發成本，而個資由資訊局加密封存保管，讓個資有完善的保護。",
          link: "",
          photo: "",
          img: "",
          bg: "#00B9CA",
          fontClr: "#FFFFFF"
        },
        {
          idx: 2,
          name: "北市府異地辦公及視訊會議",
          desc:
            "配合中央疫情指揮中心指示，在各場館逐步解封之際，如何因應可能的疫調作為是解封的必要處理項目，資訊局開發實名制APP(myCode)，提供本府所轄各公共場館以掃瞄證件條碼方式，快速完成實名登記作業，APP快速部署的特性，讓場館無須系統軟硬體的開發成本，而個資由資訊局加密封存保管，讓個資有完善的保護。",
          link: "",
          photo: "",
          img: "",
          bg: "#EB6C50",
          fontClr: "#FFFFFF"
        },
        {
          idx: 3,
          name: "資訊局-新冠肺炎資訊整合儀表板",
          desc:
            "新型冠狀病毒肺炎(COVID-19)疫情蔓延全球，臺灣在這次疫情控制上的傑出表現，獲得國際社會矚目並有意學習我國防疫之相關作法，臺北市透過線上平台、線上會議等方式，將臺北市因應新冠肺炎疫情之各項創新防疫經驗及措施分享予國際城市，對開拓及深化國際城市交流，意義重大。",
          link: "",
          photo: "",
          img: "",
          bg: "#F2F2EF",
          fontClr: "#333333"
        },
        {
          idx: 4,
          name: "場館實名制系統",
          desc: "",
          link: "",
          photo: "",
          img: "",
          bg: "#00B9CA",
          fontClr: "#FFFFFF"
        }
      ]
    };
  }
};
</script>

<style lang="sass">

.epidemic-prevention
  height: auto
  overflow-x: hidden
  overflow-y: auto
  .svg_inline
    z-index: 5
  h1
    font-weight: 700
    text-shadow: 0px 0px 30px rgba(black,0.3)
  h3
    font-size: 2.5rem
    font-weight: bold
  p
    text-shadow: 0px 0px 30px rgba(black,0.3)
  .prevent-top
    background-color: #63D1D0
    // height: 55vw
    // max-height: 700px
    overflow: hidden
    position: relative
    padding-bottom: 20px
    background-image: url(/img/index_grid.svg)
    background-size: cover
    background-position: 350% 200%

    .svg_inline
      position: absolute
      width: 90vw
      max-width: 1400px
      height: auto
      right: -20vw
      top: -5vmin
      // bottom: -10vw
    .prevent-text
      margin: 10% 0 0 50px
      color: white
      z-index: 10
      font-weight: bold
      max-width: 800px
      .prevent-subtitle
        font-size: 24px
        font-weight: bold
        color: #63D1D0
        background-color: white
        border-radius: 150px
        padding: 10px 25px
        width: fit-content
        text-align: center
      .prevent-title
        font-size: 5rem
        margin-bottom: 30px
        &.title-en
          font-size: 4rem
          white-space: pre-wrap
      .prevent-link
        font-size: 1.2rem
        margin-top: 0.5rem
        font-weight: 700
        letter-spacing: 1px
        text-shadow: 0px 0px 30px rgba(black,0.2)
        display: block
        color: white
        &.en
          font-size: 1rem
          max-width: 500px

  .prevent-item
    position: relative
    // min-height: 50vmin
    min-height: 500px
    overflow: hidden
    .prevent-item-text
      position: relative
      height: 100%
      // padding: 80px 30px 80px 150px
      padding: 20px 30px 80px 30px
      z-index: 10
      img
        opacity: 0.8
        z-index: -1
        width: 400px
        position: absolute
        left: -50px
        bottom: -50px
    &.item-r
      .prevent-item-text
        // height: 200px
        // padding: 50px 150px 50px 30px
        padding: 20px 30px 50px 30px
        // font-size: 24px
        img
          left: initial
          position: absolute
          width: 40%
          right: -15px
          bottom: -10px
    .prevent-item-pic
      overflow: hidden
      min-height: 380px
      // border-top: 15px solid rgba(26,26,26)
      // border-bottom: 15px solid rgba(26,26,26)
      // max-height: 500px
      background-repeat: no-repeat
      // background-position: center
      // background-size: cover
      height: 100%
      // transition-duration: 0.05s
      img
        // height: 100%
        display: none
        width: 100%
        height: auto
        min-width: 100%
        // max-height: 600px
  .prevent-item.en
    h3
      font-size: 2rem
    .prevent-item-text
      padding: 20px 30px 80px 30px
      // padding: 20px 30px 80px 120px
    &.item-r
      .prevent-item-text
        // padding: 20px 120px 50px 30px
        padding: 20px 30px 50px 30px

// @media (max-width: 768px)
@media (max-width: 992px)
  .epidemic-prevention
    padding-bottom: 50px
    .prevent-top
      height: 80vh
      max-height: initial
      .prevent-text
        margin: 100px 10px 10px 10px
        h1.prevent-title
          font-size: 4rem
          &.title-en
            font-size: 2.5rem
        h2.prevent-subtitle
          font-size: 18px
        .prevent-link
          font-size: 18px
      .svg_inline
        width: 200vw

        top: initial
        bottom: -45vh
        right: -80vw
    .prevent-item, .prevent-item.en
      min-height: initial
      .prevent-item-text
        padding: 30px 20px 20px 20px
        .prevent-item-img
          opacity: 0.5
      &.item-r
        .prevent-item-text
          padding: 20px 20px 50px 30px
      .prevent-item-pic
        min-height: initial
        img
          display: initial

@media (max-width: 480px)
  .epidemic-prevention
    .prevent-item.en
      .prevent-item-text
        padding: 20px
      &.item-r
        .prevent-item-text
          padding: 20px
</style>
